module.exports = __webpack_public_path__ + "static/media/pw-coins-icon.73bf10ad.svg";